import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AlbumsState } from './albums.state';

export const selectAlbumsState = createFeatureSelector<AlbumsState>('adminAlbums');

export const selectAllAlbums = createSelector(
  selectAlbumsState,
  (state: AlbumsState) => state.albums,
);

export const selectAlbumsLoading = createSelector(
  selectAlbumsState,
  (state: AlbumsState) => state.loading,
);

export const selectAlbumsError = createSelector(
  selectAlbumsState,
  (state: AlbumsState) => state.error,
);

export const selectAlbumsPagination = createSelector(
  selectAlbumsState,
  (state: AlbumsState) => state.pagination,
);

